import { render, staticRenderFns } from "./FieldControl.vue?vue&type=template&id=0d70ef5e&scoped=true"
import script from "./FieldControl.vue?vue&type=script&lang=js"
export * from "./FieldControl.vue?vue&type=script&lang=js"
import style0 from "./FieldControl.vue?vue&type=style&index=0&id=0d70ef5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70ef5e",
  null
  
)

export default component.exports